import React, { useState, useEffect } from 'react';
import { TextField, Paper, List, ListItem, ListItemButton, ListItemText } from '@mui/material';

const ClientSearch = ({ data, setSelectedInternalClientId }) => {
    const [activeClientList, setActiveClientList] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [showDropdown, setShowDropdown] = useState(false);

    useEffect(() => {
        setActiveClientList(data);
    }, [data]);

    const MAX_RESULTS = 50;

    const filteredOptions = searchText.trim()
        ? activeClientList
            .filter((client) =>
                client.name?.toLowerCase().includes(searchText.trim().toLowerCase())
            )
            .slice(0, MAX_RESULTS)
        : [];

    const handleSelect = (client) => {
        setSelectedInternalClientId(String(client.id));
        setSearchText(client.name);
        setShowDropdown(false);
    };

    return (
        <div style={{ position: 'relative', width: 390 }}>
            <TextField
                label="Search Client Name"
                variant="outlined"
                size="small"
                fullWidth
                value={searchText}
                onChange={(e) => {
                    setSearchText(e.target.value);
                    setShowDropdown(true);
                }}
                onFocus={() => {
                    if (searchText.trim()) setShowDropdown(true);
                }}
                onBlur={() => {
                    setTimeout(() => setShowDropdown(false), 100);
                }}
                InputProps={{
                    endAdornment: searchText ? (
                        <span
                            style={{
                                cursor: 'pointer',
                                padding: '0 8px',
                                color: '#888',
                                fontWeight: 'bold',
                                fontSize: '18px',
                                userSelect: 'none'
                            }}
                            onMouseDown={(e) => {
                                e.preventDefault();
                                setSearchText('');
                                setShowDropdown(false);
                            }}
                            title="Clear"
                        >
                            ×
                        </span>
                    ) : null
                }}
            />
            {showDropdown && filteredOptions.length > 0 && (
                <Paper
                    style={{
                        position: 'absolute',
                        top: 40,
                        left: 0,
                        right: 0,
                        zIndex: 10,
                        maxHeight: 200,
                        overflowY: 'auto'
                    }}
                >
                    <List>
                        {filteredOptions.map((client) => (
                            <ListItem key={client.id} disablePadding>
                                <ListItemButton onMouseDown={() => handleSelect(client)}>
                                    <ListItemText primary={client.name} />
                                </ListItemButton>
                            </ListItem>
                        ))}
                    </List>
                </Paper>
            )}
            {showDropdown && filteredOptions.length === 0 && searchText.trim() && (
                <Paper
                    style={{
                        position: 'absolute',
                        top: 40,
                        left: 0,
                        right: 0,
                        zIndex: 10
                    }}
                >
                    <List>
                        <ListItem>
                            <ListItemText primary="No matching clients" />
                        </ListItem>
                    </List>
                </Paper>
            )}
        </div>
    );
};

export default ClientSearch;